/**
 * Converts real money amount to a customer-friendly amount based on currency localization
 *
 * @param {number} amount - The amount to format
 * @param {string} currency - The currency code (e.g., 'VND', 'USD', 'EUR')
 * @returns {number} - The formatted amount
 *
 * @example
 * formatCustomerFacedAmount(12381, 'VND') // returns 13000 (rounded up to nearest thousand)
 * formatCustomerFacedAmount(12381, 'USD') // returns 12381 (no rounding)
 */
export const formatCustomerFacedAmount = (amount, currency) => {
  // For VND, round up to the nearest 1000
  // Vietnamese customers rarely see amounts like 12,381đ
  // Instead, they typically see 10,000đ or 13,000đ
  if (currency === 'VND') {
    return Math.ceil(amount / 1000) * 1000
  }

  // For other currencies, return the original amount
  return amount
}
